module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "compose",
    class: {
      minimized: _vm.minimized
    },
    attrs: {
      "id": _vm.compose_id
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.minimized),
      expression: "!minimized"
    }],
    staticClass: "full"
  }, [_c('div', {
    staticClass: "title",
    class: _vm.titleClass()
  }, [_c('span', [_vm._v(_vm._s(_vm.compose_header))]), _c('div', {
    staticClass: "close-compose",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/icons/fechar-compose.svg")
    }
  })]), _c('div', {
    staticClass: "minimize-compose",
    on: {
      "click": function($event) {
        return _vm.minimize()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/icons/minimizar-compose.svg")
    }
  })])]), _c('div', {
    staticClass: "form"
  }, [(_vm.template.kind == 'email' || _vm.task.templateKind() == 'email') ? _c('div', {
    staticClass: "label-to"
  }, [_vm._v("Para")]) : _vm._e(), (_vm.template.kind == 'email' || _vm.task.templateKind() == 'email') ? _c('div', {
    staticClass: "form-group"
  }, [(_vm.task_has_contact) ? _c('input', {
    staticClass: "contacts",
    attrs: {
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.task.contact.full_name
    }
  }) : _c('contact-autocomplete', {
    attrs: {
      "external_id": _vm.id
    },
    on: {
      "contact-selected": _vm.updateContact
    }
  }), (_vm.task_has_contact) ? _c('div', {
    staticClass: "contact-name"
  }, [_vm._v(_vm._s(_vm.task.contact.full_name)), (_vm.task.id == null) ? _c('div', {
    staticClass: "remove-contact glyphicon glyphicon-remove",
    on: {
      "click": _vm.removeContact
    }
  }) : _vm._e()]) : _vm._e()], 1) : _vm._e(), (_vm.template.kind == 'email' || _vm.task.templateKind() == 'email') ? _c('div', {
    staticClass: "cc-open",
    on: {
      "click": _vm.toggleCc
    }
  }, [_vm._v("Cc")]) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_cc),
      expression: "show_cc"
    }],
    staticClass: "cc-wrapper"
  }, [_c('div', {
    staticClass: "label-cc"
  }, [_vm._v("Cc")]), _vm._l((_vm.cc_emails), function(item, index) {
    return _c('div', {
      staticClass: "email"
    }, [_vm._v(_vm._s(item.email)), _c('div', {
      staticClass: "remove-email glyphicon glyphicon-remove",
      on: {
        "click": function($event) {
          return _vm.removeEmail(index)
        }
      }
    })])
  }), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cc_emails.length < 10),
      expression: "cc_emails.length < 10"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.cc_text),
      expression: "cc_text"
    }],
    staticClass: "cc",
    domProps: {
      "value": (_vm.cc_text)
    },
    on: {
      "blur": _vm.blurCc,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cc_text = $event.target.value
      }
    }
  })], 2), _c('div', {
    staticClass: "clear"
  }), (_vm.template.kind == 'email' || _vm.task.templateKind() == 'email') ? _c('div', {
    staticClass: "form-group",
    class: _vm.subject_group_class
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subject),
      expression: "subject"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "subject",
    attrs: {
      "placeholder": "Assunto",
      "name": "subject",
      "type": "text"
    },
    domProps: {
      "value": (_vm.subject)
    },
    on: {
      "blur": _vm.updateLastSubjectCursorPosition,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.subject = $event.target.value
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subject_help_text),
      expression: "subject_help_text"
    }],
    key: "subject",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.subject_help_text))])]), _c('variables-dropdown', {
    class: {
      cc: _vm.show_cc
    },
    attrs: {
      "id": "subject-variables",
      "variables": _vm.variables
    },
    on: {
      "add-variable": _vm.addVariableToSubject
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "clear"
  }), _c('div', {
    staticClass: "form-group white-border",
    class: {
      'has-error': _vm.errors.has('body')
    }
  }, [_c('div', {
    staticClass: "label-body"
  }, [_vm._v(_vm._s(_vm.template.id ? _vm.contentLabel(_vm.template.kind) : _vm.contentLabel(_vm.task.templateKind())))]), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "body",
    attrs: {
      "id": "body",
      "name": "body"
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('body')),
      expression: "errors.has('body')"
    }],
    key: "body",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('body')))])]), _c('variables-dropdown', {
    class: {
      cc: _vm.show_cc
    },
    attrs: {
      "id": "body-variables",
      "variables": _vm.variables
    },
    on: {
      "add-variable": _vm.addVariableToBody
    },
    nativeOn: {
      "mousedown": function($event) {
        $event.preventDefault();
        return _vm.saveSummernoteRange.apply(null, arguments)
      }
    }
  })], 1), _c('div', {
    staticClass: "form-group white-border"
  }, [(_vm.files.length != 0) ? _c('div', _vm._l((_vm.files), function(file, index) {
    return _c('div', [_c('div', {
      staticClass: "attachment",
      class: {
        'text-uploading': file.uploading
      }
    }, [(file.uploading) ? _c('div', {
      staticClass: "progress-bar-upload",
      style: ({
        width: file.progress + '%'
      })
    }) : _vm._e(), _c('span', {
      staticClass: "file-name"
    }, [_vm._v(_vm._s(file.name))]), _c('span', [_vm._v("(" + _vm._s(file.size / 1000) + " KB)")]), (!file.uploading) ? _c('button', {
      staticClass: "close",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeFile(index)
        }
      }
    }, [_c('span', [_vm._v("×")])]) : _vm._e()])])
  }), 0) : _vm._e()])]), _c('div', {
    staticClass: "footer"
  }, [(_vm.allow_change_template) ? _c('template-autocomplete', {
    attrs: {
      "external_id": _vm.id,
      "kind": _vm.task.templateKind()
    },
    on: {
      "template-selected": _vm.updateTemplate,
      "hide": _vm.hideTemplateAutocomplete
    }
  }) : _vm._e(), _c('img', {
    staticClass: "templates",
    attrs: {
      "src": require("../../../assets/images/icons/templates-compose.svg"),
      "data-toggle": "tooltip",
      "title": _vm.template_name,
      "data-placement": "top"
    },
    on: {
      "click": _vm.toggleTemplateAutocomplete
    }
  }), _c('img', {
    attrs: {
      "src": require("../../../assets/images/icons/diagramacao-compose.svg")
    },
    on: {
      "click": function($event) {
        return _vm.toggleToolbar()
      }
    }
  }), (_vm.files.length < 5 && _vm.current_user.isNylas() && !_vm.is_meeting_schedule) ? _c('img', {
    attrs: {
      "src": require("../../../assets/images/icons/anexo.svg")
    },
    on: {
      "click": function($event) {
        return _vm.chooseFiles()
      }
    }
  }) : _vm._e(), (_vm.task.isSocialTask()) ? _c('div', {
    staticClass: "btn-primary btn whatsapp-icon",
    class: {
      disabled: !_vm.contact_has_cellphone
    },
    on: {
      "click": _vm.toWhatsapp
    }
  }, [_c('img', {
    class: {
      disabled: !_vm.contact_has_cellphone
    },
    attrs: {
      "src": require("../../../assets/images/icons/icon-whatsapp.svg")
    }
  })]) : _vm._e(), (_vm.task.isLikedinTask()) ? _c('div', {
    staticClass: "btn-primary btn linkedin-icon",
    on: {
      "click": _vm.toLinkedin
    }
  }, [_vm._v("Copiar e Abrir Linkedin"), _c('img', {
    attrs: {
      "src": require("../../../assets/images/icons/icon-linkedin.svg")
    }
  })]) : _vm._e(), (_vm.task.templateKind() == 'email' && !_vm.is_meeting_schedule) ? _c('div', {
    staticClass: "btn-primary btn btn-send",
    attrs: {
      "disabled": _vm.loading || _vm.isUploading()
    },
    on: {
      "click": function($event) {
        return _vm.submit(true)
      }
    }
  }, [_vm._v("Enviar")]) : (!_vm.copied && !_vm.is_meeting_schedule) ? _c('div', {
    staticClass: "btn-primary btn",
    on: {
      "click": function($event) {
        return _vm.copy()
      }
    }
  }, [_vm._v("Copiar")]) : (!_vm.is_meeting_schedule) ? _c('div', {
    staticClass: "btn-primary btn",
    on: {
      "click": function($event) {
        return _vm.doneTask()
      }
    }
  }, [_vm._v("Finalizar")]) : _vm._e(), (!_vm.is_meeting_schedule && _vm.task.isEmailTask()) ? _c('div', {
    staticClass: "btn-primary btn-calendar btn",
    class: {
      scheduled: _vm.task.isScheduled()
    },
    on: {
      "click": function($event) {
        return _vm.openScheduler()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/icons/calendar.svg")
    }
  })]) : _vm._e(), (_vm.is_meeting_schedule) ? _c('div', {
    staticClass: "btn-primary btn",
    on: {
      "click": function($event) {
        return _vm.submit(false, true)
      }
    }
  }, [_vm._v("Agendar lembrete")]) : _vm._e(), (!_vm.is_meeting_schedule) ? _c('div', {
    staticClass: "btn-primary btn-save btn",
    attrs: {
      "disabled": _vm.loading || _vm.isUploading()
    },
    on: {
      "click": function($event) {
        return _vm.submit(false)
      }
    }
  }, [_vm._v("Salvar")]) : _vm._e(), _c('input', {
    ref: "fileUpload",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "fileUpload",
      "type": "file"
    },
    on: {
      "change": _vm.selectAttachment
    }
  }), _c('div', {
    staticClass: "vertical-separator"
  })], 1)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.minimized),
      expression: "minimized"
    }],
    staticClass: "minimized"
  }, [_c('div', {
    staticClass: "title",
    class: _vm.template.kind
  }, [_c('span', [_vm._v(_vm._s(_vm.compose_header))]), _c('div', {
    staticClass: "close-compose",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/icons/fechar-compose.svg")
    }
  })]), _c('div', {
    staticClass: "minimize-compose",
    on: {
      "click": function($event) {
        return _vm.minimize()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/icons/maximizar-compose.svg")
    }
  })])])]), (_vm.show_scheduler) ? _c('scheduler', {
    attrs: {
      "task": _vm.task,
      "loading": _vm.loading,
      "number_composes": _vm.number_composes,
      "event": _vm.event
    },
    on: {
      "close-scheduler": function($event) {
        return _vm.closeScheduler()
      },
      "schedule-meeting-date": _vm.setMeetingReminderDate,
      "schedule-email-send": _vm.handleSchedueEmailEvent
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-31967fb9!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shared/compose/list_item.vue
// module id = 1071
// module chunks = 1